import { DropdownButton } from './dropdown-button.js';

export class ActionSelect extends DropdownButton {
    static defaultOptions = {
      componentName: 'ActionSelect',
      icon: 'smile',
      dropDown: {
        width: 660,
        maxHeight: 400
      }
    };

    constructor (options, editor, vr) {
      super(ActionSelect.initOptions($.extend({}, ActionSelect.defaultOptions, options)));
      this.vr = vr;
      this.editor = editor;
      this.actionPanelOpen = false;
      this.actionTypes = this.getActionTypes();

      // clear active item after saved
      this.activeItem = null;
      this.hotspotsPanel = null;

      this.generateActionSelectControlsAndPanel();
      this.positionActionTypePanel();

      this.button.el.on('click', function (e) {
        this.actionPanelOpen = !this.actionPanelOpen;
        this.loadHotspotActionOptions();
      }.bind(this));

      $(document).ready(function () {
        this.loadPopupData();
      }.bind(this));

      this.dropDown.shim.on('click', function () {
        this.triggerCloseEvent();
      }.bind(this));
    }

    generateActionSelectControlsAndPanel () {
      this.actionHeading = $('<label>Action Types</label>');
      this.dropDown.add(this.actionHeading);

      this.actionTypeListContainer = $('<ul class="ca-ui-actionselect_tab-container"></ul>');
      this.dropDown.add(this.actionTypeListContainer);

      this.actionTypeContentContainer = $('<div></div>');
      this.dropDown.add(this.actionTypeContentContainer);

      for (const index in this.actionTypes) {
        const actionTypeTab = this.createActionTypeTabs(this.actionTypes[index]);
        this.actionTypeListContainer.append(actionTypeTab);

        const actionTypeContent = this.createActionTypeTabContent(this.actionTypes[index]);
        this.actionTypeContentContainer.append(actionTypeContent);
      }

      this.actionTypeSaveContainer = $("<div class='ca-ui-action_savemenu'></div>");
      this.dropDown.add(this.actionTypeSaveContainer);
      this.actionTypeSaveMessage = $('<div class="ca-ui-action_errormessage"></div>');
      this.actionTypeSaveContainer.append(this.actionTypeSaveMessage);
      this.actionTypeSaveContainer.append(this.createCancelActionButton());
      this.actionTypeSaveContainer.append(this.createSaveActionButton());
    }

    triggerCloseEvent () {
      if (this.actionPanelOpen) {
        this.saveAction();
        this.actionPanelOpen = false;
      }
    }

    // loads existing hotspot options as saved
    loadHotspotActionOptions () {
      let actionType;
      if (this.editor.selected.options.action !== undefined) {
        actionType = this.editor.selected.options.action.type;
      } else {
        actionType = {};
      }

      console.log(this.editor.selected.options);

      let actionInfo;
      if (actionType === 'popup') { // space reseved for future ticket
      } else if (actionType === 'url') {
        actionInfo = this.editor.selected.options.action.actionInfo;
        $('#url_input').val(actionInfo.urlToVisit);

        if (actionInfo.openInNewTab) {
          $('#new_tab').prop('checked', true);
        } else {
          $('#same_tab').prop('checked', true);
        }
      } else if (actionType === 'download') {
        actionInfo = this.editor.selected.options.action.actionInfo;

        const downloadInputContainer = $('#download_input-container');
        let downloadInputResult = $('#download_input_result_info');
        let readableDate = new Date(actionInfo.assetData.created_at);
        readableDate = readableDate.toLocaleString('en-AU');
        if (downloadInputResult) {
          downloadInputResult.remove();
        }

        downloadInputResult = $(`
          <div id="download_input_result_info">
            <div class="download-input-result_image-container">
                <img src="${
                actionInfo.assetLink
            }" />
            </div>
            <div class="download-input-result_image-details">
                <p>Name: ${
                actionInfo.assetData.title
            }</p>
                <p>Type: ${
                actionInfo.assetData.type
            }</p>
                <p>Uploaded at ${readableDate} by ${
                actionInfo.assetData.user.name
            }</p>
                <p>Size: ${
  (parseFloat(actionInfo.assetData.original.metadata.upload_data.filesize) * 0.001)
            }kb</p>
            </div>
          </div>
      `);

        downloadInputContainer.append(downloadInputResult);
      } else if (actionType === 'none') { // space reseved for future ticket
      }

      $('#media_picker_start').on('click', function () {
        console.log('controlled by action select media picker');
        this.editor.openMediaPicker((data) => this.setMediaDownload(data));
      }.bind(this));

      this.refreshActionSelectPanel();
    }

    setMediaDownload (data) {
      this.mediaData = data.data;
      const downloadInputContainer = $('#download_input-container');
      let downloadInputResult = $('#download_input_result_info');
      let readableDate = new Date(data.data.created_at);
      readableDate = readableDate.toLocaleString('en-AU');

      if (downloadInputResult) {
        downloadInputResult.remove();
      }

      downloadInputResult = $(`

          <div id="download_input_result_info">
            <div class="download-input-result_image-container">
                <img src="${
            data.data.url
        }" />
            </div>
            <div class="download-input-result_image-details">
                <p>Name: ${
            data.data.title
        }</p>
                <p>Type: ${
            data.data.type
        }</p>
                <p>Uploaded at ${readableDate} by ${
            data.data.user.name
        }</p>
                <p>Size: ${
  (parseFloat(data.data.original.metadata.upload_data.filesize) * 0.001)
        }kb</p>
            </div>
          </div>
          `);

      downloadInputContainer.append(downloadInputResult);
    }

    loadPopupData () {
      this.projectId = this.editor.getProjectId();
      this.contentId = this.editor.getClientId();
      this.auth = this.editor.getAuth();
      this.userUUID = this.editor.getUserUUID();

      this.getPopupData(this.projectId, this.auth, this.contentId);
    }

    getPopupData (projectId, auth, contentId) {
      $.ajax({
        url: `${
                this.editor.apiUrl
            }/contents?filter[project_id]=${projectId}&filter[type]=modal&limit=-1`,
        headers: {
          Authorization: 'Bearer ' + auth,
          'Content-Type': 'application/json',
          Accept: 'application/json'
        }
      }).done((data) => {
        this.populatePopupInputFields(data);

        const addPopupBtnWelcome = $('#popup_list.ca-welcome_popup-selector').siblings('#add_popup');
        const editPopupBtnWelcome = $('#popup_list.ca-welcome_popup-selector').siblings('#edit_popup');

        const addPopupBtnHotspot = $('#popup_list.ca-hotspot_popup-selector').siblings('#add_popup');
        const editPopupBtnHotspot = $('#popup_list.ca-hotspot_popup-selector').siblings('#edit_popup');

        addPopupBtnWelcome.on('click', function () {
          this.createNewPopup($('#popup_list.ca-welcome_popup-selector'));
        }.bind(this));

        editPopupBtnWelcome.on('click', function () {
          this.editExistingPopup($('#popup_list.ca-welcome_popup-selector option:selected').val());
        }.bind(this));

        addPopupBtnHotspot.on('click', function () {
          this.createNewPopup($('#popup_list.ca-hotspot_popup-selector'));
        }.bind(this));

        editPopupBtnHotspot.on('click', function () {
          this.editExistingPopup($('#popup_list.ca-hotspot_popup-selector option:selected').val());
        }.bind(this));
      }).fail((e) => {
        if (e.responseJSON) {
          alert(e.responseJSON.message);
        }
      }).always(() => {});
      return null;
    }

    populatePopupInputFields (popupList) {
      if (popupList.data.length === 0) {
        const popupInputListWelcome = $('#popup_list.ca-welcome_popup-selector');
        const popupInputListHotspotAction = $('#popup_list.ca-hotspot_popup-selector');
        popupInputListWelcome.append($('<option>', {
          value: 'none',
          text: 'No popups exist. Create a new popup below.',
          disabled: true,
          selected: true
        }));
        popupInputListWelcome.change();

        popupInputListHotspotAction.append($('<option>', {
          value: 'none',
          text: 'No popups exist. Create a new popup below.',
          disabled: true,
          selected: true
        }));
        popupInputListHotspotAction.change();
      } else {
        const popupInputListWelcome = $('#popup_list.ca-welcome_popup-selector');
        const popupInputListHotspotAction = $('#popup_list.ca-hotspot_popup-selector');
        let popupIdToExclude = '';
        popupList.data.forEach(popupEntry => {
          let idToUse;
          let className;
          if (popupEntry.draft_id !== undefined && popupEntry.draft_id !== null) {
            idToUse = popupEntry.draft_id;
          } else if (popupEntry.id !== undefined && popupEntry.id !== null) {
            idToUse = popupEntry.id;
          }

          let textToUse;
          if (popupEntry.published_status === 'published') {
            textToUse = popupEntry.name;
            className = '';
          } else {
            textToUse = popupEntry.name + ' [Not Published]';
            className = 'ca-vr_popup-selector_draft';
          }

          // if a draft id is present, loop through and see if we can find a match with another popup id
          // if a match, flag this value as don't include

          if (popupEntry.draft_id !== null) {
            const popupIdToCompare = popupEntry.draft_id;
            for (let i = 0; i < popupList.data.length; i++) {
              if (popupIdToCompare === popupList.data[i].id) {
                popupIdToExclude = popupList.data[i].id;
                break;
              }
            }
          }
          if (popupIdToExclude !== popupEntry.id) {
            popupInputListWelcome.append($('<option>', {
              id: idToUse,
              value: idToUse,
              text: textToUse,
              class: className,
              selected: !!(this.vr.options.welcomeContent && this.vr.options.welcomeContent.id && this.vr.options.welcomeContent.id === idToUse)
            }));

            popupInputListHotspotAction.append($('<option>', {
              id: idToUse,
              value: idToUse,
              text: textToUse,
              class: className
            }));
          }
        });
        popupInputListWelcome.change();
        popupInputListHotspotAction.change();
      }
    }

    createNewPopup (optionSelectLocation) {
      const popupObject = JSON.stringify(this.defaultNewPopupTypeObject(this.clientId, this.projectId));
      $.post({
        url: `${
                this.editor.apiUrl
            }/contents/`,
        data: popupObject,
        dataType: 'json',
        headers: {
          Authorization: 'Bearer ' + this.auth,
          'Content-Type': 'application/json',
          Accept: 'application/json'
        }
      }).done((data) => {
        if (optionSelectLocation.hasClass('ca-hotspot_popup-selector')) {
          $('#popup_list.ca-hotspot_popup-selector').append($('<option>', {
            id: data.data.id,
            value: data.data.id,
            text: 'New [Not Published]',
            class: 'ca-vr_popup-selector_draft'
          }));
          $('#popup_list.ca-hotspot_popup-selector').val(data.data.id);
          $('#popup_list.ca-hotspot_popup-selector').change();
          this.triggerCloseEvent();
        } else if (optionSelectLocation.hasClass('ca-welcome_popup-selector')) {
          $('#popup_list.ca-welcome_popup-selector').append($('<option>', {
            id: data.data.id,
            value: data.data.id,
            text: 'New [Not Published]',
            class: 'ca-vr_popup-selector_draft'
          }));
          $('#popup_list.ca-welcome_popup-selector').val(data.data.id);
          $('#popup_list.ca-welcome_popup-selector').change();
          this.triggerCloseEvent();
        }
        window.open(`${
                this.editor.cmsUrl
            }/clients/${
                this.editor.clientSlug
            }/projects/${
                this.editor.projectSlug
            }/modal/${
                data.data.id
            }/edit`, '_blank');
      }).fail((e) => {
        alert(e.responseJSON.message);
      }).always(() => {});
    }

    editExistingPopup (popupValue) {
      const selectedPopupValue = popupValue;
      window.open(`${
            this.editor.cmsUrl
        }/clients/${
            this.editor.clientSlug
        }/projects/${
            this.editor.projectSlug
        }/modal/${selectedPopupValue}/edit`, '_blank');
    }

    createActionTypeTabs (action) {
      const actionTab = $(`<li class="ca-ui-actionselect_tab" id="${
            action.id
        }">
            ${
            action.name
        }
            </li>`);

      actionTab.on('click', function (e) {
        this.switchActionTab(e.target.id, `${
                e.target.id
            }_content`);
      }.bind(this));

      return actionTab;
    }

    createActionTypeTabContent (action) {
      const actionTabContent = $(`
            <div id="${
            action.id
        }_content" class="ca-ui-actionselect_content">
                <div class="ca-ui-actionselect_content-description">${
            action.description
        }</div>
                <div class="ca-ui-actionselect_content-input" id="${
            action.id
        }_input-container">
                    ${
            action.inputContent
        }
                </div>
            </div>;
        `);
      return actionTabContent;
    }

    createCancelActionButton () {
      const cancelButton = $('<button id="cancel_action">Cancel</button>');
      cancelButton.on('click', function (e) {
        $('.ca-ui-popupsurface').removeClass('open');
      });
      return cancelButton;
    }

    createSaveActionButton () {
      const saveButton = $('<button id="save_action">Save Action</button>');
      saveButton.on('click', function (e) {
        this.saveAction();
        $('.ca-ui-popupsurface').removeClass('open');
        this.actionPanelOpen = false;
      }.bind(this));
      return saveButton;
    }

    switchActionTab (tab, content) {
      const tabContent = document.getElementsByClassName('ca-ui-actionselect_content');
      for (let i = 0; i < tabContent.length; i++) {
        tabContent[i].style.display = 'none';
      }
      document.getElementById(content).style.display = 'block';

      const tabMenuItems = document.getElementsByClassName('ca-ui-actionselect_tab');
      for (let j = 0; j < tabMenuItems.length; j++) {
        tabMenuItems[j].className = 'ca-ui-actionselect_tab';
      }

      document.getElementById(tab).className = 'ca-ui-actionselect_tab active';
    }

    saveAction () {
      const actionToSave = {
        type: '',
        actionInfo: {}
      };
      let actionType;
      let inputs;
      // get current tab selected
      const tabContent = document.getElementsByClassName('ca-ui-actionselect_tab');
      for (let i = 0; i < tabContent.length; i++) {
        if ($(tabContent[i]).hasClass('active')) {
          actionType = $(tabContent[i]);
          actionType = actionType.attr('id');
          inputs = $(`#${actionType}_content :input`);
        }
      }
      if (actionType === 'popup') {
        actionToSave.type = 'popup';
        actionToSave.actionInfo = {
          popupUrl: '',
          content: {}
        };

        actionToSave.actionInfo.popupUrl = $(inputs[0]).val();
        this.getPopupContent(actionToSave, actionToSave.actionInfo.popupUrl);
      } else if (actionType === 'url') {
        actionToSave.type = 'url';
        actionToSave.actionInfo = {
          urlToVisit: '',
          openInNewTab: ''
        };
        actionToSave.actionInfo.urlToVisit = $(inputs[0]).val();
        if ($(inputs[1]).is(':checked')) {
          actionToSave.actionInfo.openInNewTab = true;
        } else {
          actionToSave.actionInfo.openInNewTab = false;
        }
        this.editor.selected.setAction(actionToSave);
      } else if (actionType === 'download') {
        actionToSave.type = 'download';
        actionToSave.actionInfo = {
          assetLink: '',
          assetData: ''
        };
        actionToSave.actionInfo.assetLink = this.mediaData.type === 'document' ? this.mediaData.url + '.pdf' : this.mediaData.url;
        actionToSave.actionInfo.assetData = this.mediaData;
        this.editor.selected.setAction(actionToSave);
      }

      if (!actionToSave) {
        $('.ca-ui-action_errormessage').text('No Action to save. Please set an action before attempting to save');
      }
    }

    static initOptions (options) {
      options.button = {
        label: 'Change',
        icon: options.icon
      };
      return options;
    }

    positionActionTypePanel () { // align panel to right of editor panel
      this.editorPanel = $('.ca-vr_editorpanel');
      this.dropDown.css(
        'left',
            `${
                this.editorPanel.width() + 10
            }px`
      );
      this.dropDown.css('top', '46.5%');
      this.dropDown.css('width', '100%');
      this.dropDown.css('max-width', '400px');
      this.dropDown.css('padding', '20px');
    }

    refreshActionSelectPanel () {
      const hotspot = this.editor.selected;
      if (hotspot.options.action !== undefined) {
        this.switchActionTab(hotspot.options.action.type, `${hotspot.options.action.type}_content`);
        if (hotspot.options.action.type === 'popup') {
          $('#popup_list.ca-hotspot_popup-selector').val(hotspot.options.action.actionInfo.popupId).prop('selected', true);
          $('#url_input').val('');
          const downloadInfo = $('#download_input_result_info');
          if (downloadInfo !== undefined) {
            $('#download_input_result_info').empty();
          }
        } else if (hotspot.options.action.type === 'url') {
          const downloadInfo = $('#download_input_result_info');
          $('#url_input').val(hotspot.options.action.actionInfo.urlToVisit);
          if (downloadInfo !== undefined) {
            $('#download_input_result_info').empty();
          }
        } else if (hotspot.options.action.type === 'download') {
          $('#url_input').val('');
        }
      } else {
        this.switchActionTab('none', 'none_content');
        $('#url_input').val('');
        const downloadInfo = $('#download_input_result_info');
        if (downloadInfo !== undefined) {
          $('#download_input_result_info').empty();
        }
      }
    }

    setAction (action) {}

    getAction (action) {}

    getActionTypes () {
      const actionTypes = [
        {
          id: 'popup',
          name: 'Popup',
          description: 'Select new or existing popup to display',
          inputContent: `<label for='popup_list'>Select a popup</label>
                                <select id='popup_list' class='ca-hotspot_popup-selector' name='popup_list'></select>
                                <button id='add_popup'>Add Popup</button><button id='edit_popup'>Edit Popup</button>`
        }, {
          id: 'url',
          name: 'URL',
          description: 'Hotspot will navigate to nominated URL in new tab',
          inputContent: `
                                <div>
                                    <label for="url_input">Type or paste the url you would like to use.</label>
                                    <input type='text' id='url_input' name='url_input'>
                                </div>

                                <div class="ca-ui-actionselect_url-newtab">
                                    <div>Open in new tab?</div>
                                    <div class="ca-ui-actionselect_url-newtab-inputs">
                                        <input type='radio' id='new_tab' name='tab_open_setting' value='yes'>
                                        <label id='new_tab_label' class="pill-select" for='new_tab'>Yes</label>

                                        <input type='radio' id='same_tab' name='tab_open_setting' value='no'>
                                        <label id='same_tab_label' class="pill-select" for='same_tab'>No</label>
                                    </div>

                                </div>`
        }, {
          id: 'download',
          name: 'Download',
          description: 'Upload or select existing media asset to display',
          inputContent: `<p>Download a file</p>
                                <button id="media_picker_start">Select media</button>`
        }, {
          id: 'none',
          name: 'None',
          description: 'Selecting this will designate hotspot to do nothing',
          inputContent: ''
        }
      ];
      return actionTypes;
    }

    defaultNewPopupTypeObject (clientId, projectId) {
      const newPopup = {
        project_id: projectId,
        user_id: this.userUUID,
        name: 'New',
        published_status: 'draft',
        metadata: '{}',
        type: 'modal'
      };
      return newPopup;
    }

    getPopupContent (actionToSave, popupId) {
      this.vr.showLoading('Saving hotspot...');
      $.ajax({
        url: `${
                this.editor.apiUrl
            }/contents/${popupId}`,
        headers: {
          Authorization: 'Bearer ' + this.auth,
          'Content-Type': 'application/json',
          Accept: 'application/json'
        }
      }).done(function (data) {
        console.log(data);
        actionToSave.actionInfo = {
          popupId: popupId,
          content: data
        };
        this.editor.selected.appendActionLinkToHotspot(actionToSave);
        console.log(this.editor.selected.options);
      }.bind(this)).fail((e) => {
        if (e.responseJSON) {
          alert(e.responseJSON.message);
        }
      }).always(function () {
        this.vr.hideLoading();
      }.bind(this));
      return null;
    }
}
